import React from 'react'
import { Slide } from "react-awesome-reveal";
import { Link } from 'react-router-dom'
import shape1 from '../../images/footer-shape-1.svg'
import shape2 from '../../images/footer-shape-2.svg'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const Footer = (props) => {
    return (
        <footer className={`wpo-site-footer ${props.footerClass}`}>
            <div className="wpo-upper-footer">
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col col-md-12 col-sm-12 col-12 text-center">
                            <div className="widget wpo-service-link-widget">
                                <div className="widget-title text-center">
                                    <h3>Contacto para dudas y confirmaciones</h3>
                                </div>
                                <div className="contact-ft">
                                    <div className="contact-item" style={{ marginBottom: '25px' }}>
                                        <p style={{ marginBottom: '8px' }}>Asistente Virtual:</p>
                                        <a href="https://wa.me/5215525343404" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                                            <i className="ti-comments" style={{ fontSize: '18px' }}></i>
                                            <span>+52 1 55 2534 3404</span>
                                        </a>
                                    </div>
                                    <div className="contact-item">
                                        <p style={{ marginBottom: '8px' }}>Ericka Lazarini - Wedding Planner:</p>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px' }}>
                                            <a href="https://wa.me/5215522719079" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <i className="ti-comments" style={{ fontSize: '18px' }}></i>
                                                <span>+52 1 55 2271 9079</span>
                                            </a>
                                            <a href="https://instagram.com/erickaplanner" target="_blank" rel="noopener noreferrer" style={{ color: '#fff' }}>
                                                <i className="ti-instagram" style={{ fontSize: '18px' }}></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-xs-12">
                            <p className="copyright">
                                &copy; Copyright 2025 <br /> Hecho con ❤️ por <a href="https://parsel.dev" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>Pársel</a></p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="ft-shape-1">
                <Slide direction="left" duration="1000" triggerOnce="true">
                    <img src={shape1} alt="" />
                </Slide>
            </div>
            <div className="ft-shape-2">
                <Slide direction="right" duration="1200" triggerOnce="true">
                    <img src={shape2} alt="" />
                </Slide>
            </div>
        </footer>
    )
}

export default Footer;